import {
    CAYG1, CAYG2, MCHP1, MCHP2, MCHP3, Base1, Base2, Base3,
    Fabcom1, Fabcom2, UAT1, UAT2, UAT3, LabelPics1, LabelPics2,
    ExplodingGoats1, ExplodingGoats2, ExplodingGoats3,
} from '../assets/img';

const projects = [
    {
        id: 'close-as-you-go', client: 'Deloitte', title: 'A clearer view of the financial close.',
        name: 'Close as You Go', role: 'UX/UI architecture & development',
        summary: 'Making complex public-sector financial workflows easier to understand, navigate, and manage.',
        tags: ['React', 'UX architecture', 'Visual identity'],
        context: 'Close as You Go is a financial management tool for public-sector teams working through the financial close process.',
        contribution: 'I led the UX/UI design and development, built the React interface, and created the logo and custom 3D assets to give the product a cohesive visual identity.',
        result: 'An interface that brings financial information and close-management workflows together, helping teams review data and manage their work in one place.',
        images: [CAYG1, CAYG2], captions: ['Organization overview and financial dashboard', 'Financial close detail and management workflow'],
    },
    {
        id: 'microchip', client: 'Microchip Technology', title: 'Evolving an enterprise web platform.',
        name: 'Microchip.com', role: 'Web architecture & frontend development',
        summary: 'A journey from a static website to a connected, component-based web application.',
        tags: ['Vue.js', 'AngularJS', 'Sitefinity'],
        context: 'Microchip’s website needed to evolve beyond a static platform and support a more dynamic experience.',
        contribution: 'As principal architect, I led the move to Sitefinity on .NET with an AngularJS frontend. I later guided the transition to a custom Vue.js application, alongside the site redesign.',
        result: 'A modernized platform with a more standardized frontend and connected content experience across the site.',
        images: [MCHP1, MCHP2, MCHP3], captions: ['Microchip website homepage', 'Product and content experience', 'Product discovery interface'],
    },
    {
        id: 'admin-panel', client: 'Enterprise administration', title: 'Complex access. Simple oversight.',
        name: 'Server & user administration', role: 'Product design & development',
        summary: 'Bringing servers, user access, and system logs into one understandable workspace.',
        tags: ['UX/UI design', 'Administration', 'System visibility'],
        context: 'Administrators needed a clear view of servers, users, and access within an organizational system.',
        contribution: 'I designed and developed the application, including server and user views, access management, and interfaces for reviewing system logs.',
        result: 'A central workspace where administrators can manage access and users can understand their own permissions and review logs.',
        images: [Base1, Base2, Base3], captions: ['Server management overview', 'System overview and activity dashboard', 'User administration interface'],
    },
    {
        id: 'fabcom', client: 'FabCom', title: 'An interactive agency experience.',
        name: 'FabCom website', role: 'Web development & interaction design',
        summary: 'Creative navigation and dynamic content for an integrated marketing agency.',
        tags: ['JavaScript', 'ExpressionEngine', 'Interaction design'],
        context: 'FabCom wanted an engaging website that reflected the agency’s creative approach.',
        contribution: 'I worked with the art director to develop the site and an interactive menu system, using ExpressionEngine, HTML, CSS, and JavaScript.',
        result: 'An interactive website that surfaces relevant agency content through its navigation.',
        images: [Fabcom1, Fabcom2], captions: ['FabCom agency website', 'Interactive agency navigation'],
    },
    {
        id: 'uat', client: 'University of Advancing Technology', title: 'Helping students explore what’s next.',
        name: 'UAT website', role: 'Web design & development',
        summary: 'An interactive way to discover technology degrees and explore university content.',
        tags: ['JavaScript', 'PHP', 'Web design'],
        context: 'The university needed to help prospective students discover its range of technology-focused degrees.',
        contribution: 'I designed and implemented the homepage degree carousel and worked on the design and development of most site pages, using PHP and JavaScript for dynamic content.',
        result: 'A browsable degree experience supported by the wider university website.',
        images: [UAT1, UAT2, UAT3], captions: ['University homepage', 'Degree exploration experience', 'University content page'],
    },
    {
        id: 'label-pics', client: 'Label Pics', title: 'A small tool for busy classrooms.',
        name: 'Label Pics', role: 'Mobile app development',
        summary: 'Helping early childhood educators turn photos into custom classroom labels.',
        tags: ['Cordova', 'iOS & Android', 'JavaScript'],
        context: 'Early childhood professionals need an efficient way to create custom photo labels for their classrooms.',
        contribution: 'I developed the cross-platform utility using Cordova, HTML, CSS, and JavaScript.',
        result: 'A photo-labeling workflow designed for educators on both iOS and Android.',
        images: [LabelPics1, LabelPics2], captions: ['Label Pics mobile application', 'Classroom photo-labeling workflow'],
    },
    {
        id: 'exploding-goats', client: 'Independent project', title: 'Learning Swift, one goat at a time.',
        name: 'Exploding Goats', role: 'Game design & Swift development',
        summary: 'A playful side-scrolling game built as a hands-on exploration of Swift.',
        tags: ['Swift', 'iOS', 'Game development'],
        context: 'I wanted to learn Swift by taking a complete mobile game from concept to a working application.',
        contribution: 'I built a side-scrolling game in which players time screen taps to send goats into a gully while avoiding dynamite.',
        result: 'A functional mobile game and a practical proof of concept for my work in Swift.',
        images: [ExplodingGoats1, ExplodingGoats2, ExplodingGoats3], captions: ['Exploding Goats gameplay', 'Side-scrolling game scene', 'Game interface'],
    },
];

export default projects;
